/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PayableMagicianWrapperMock,
  PayableMagicianWrapperMockInterface,
} from "../PayableMagicianWrapperMock";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_magician",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "EmptyAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "magician",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type PayableMagicianWrapperMockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: PayableMagicianWrapperMockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class PayableMagicianWrapperMock__factory extends ContractFactory {
  constructor(...args: PayableMagicianWrapperMockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PayableMagicianWrapperMock";
  }

  deploy(
    _magician: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PayableMagicianWrapperMock> {
    return super.deploy(
      _magician,
      overrides || {}
    ) as Promise<PayableMagicianWrapperMock>;
  }
  getDeployTransaction(
    _magician: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_magician, overrides || {});
  }
  attach(address: string): PayableMagicianWrapperMock {
    return super.attach(address) as PayableMagicianWrapperMock;
  }
  connect(signer: Signer): PayableMagicianWrapperMock__factory {
    return super.connect(signer) as PayableMagicianWrapperMock__factory;
  }
  static readonly contractName: "PayableMagicianWrapperMock";
  public readonly contractName: "PayableMagicianWrapperMock";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PayableMagicianWrapperMockInterface {
    return new utils.Interface(_abi) as PayableMagicianWrapperMockInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PayableMagicianWrapperMock {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PayableMagicianWrapperMock;
  }
}
